import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Tutorial } from '../models';

@Injectable()
export abstract class TutorialsService {
    /** fetch the currently available tutorials */
    abstract tutorials(): Observable<Tutorial[]>;
}
